<select class="mm-single-select"
        [class.mm-dark]="style === 'dark'"
        [value]="internalValue"
        (change)="onSelectChange($event)"
        (blur)="onTouched()"
        [disabled]="disabled">
    <option *ngFor="let option of options"
            [value]="option.value"> {{option.label}}
    </option>
</select>
